export const ATHENA_ZOCDOC30NP_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_ZOCDOC30NP_APPOINTMENT_TYPE_ID;
export const ATHENA_ZOCDOC15NP_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_ZOCDOC15NP_APPOINTMENT_TYPE_ID;
export const ATHENA_CONSULT30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_CONSULT30_APPOINTMENT_TYPE_ID;
export const ATHENA_FOLLOWUP15_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_FOLLOWUP15_APPOINTMENT_TYPE_ID;
export const ATHENA_RETURNVISIT30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_RETURNVISIT30_APPOINTMENT_TYPE_ID;
export const ATHENA_MEMBER_CONSULT30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_MEMBER_CONSULT30_APPOINTMENT_TYPE_ID;
export const ATHENA_MEMBER_FOLLOWUP15_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_MEMBER_FOLLOWUP15_APPOINTMENT_TYPE_ID;
export const ATHENA_MEMBER_FOLLOWUP30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_MEMBER_FOLLOWUP30_APPOINTMENT_TYPE_ID;
export const ATHENA_NEWVISIT30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_NEWVISIT30_APPOINTMENT_TYPE_ID;
export const ATHENA_FUVISIT15_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_FUVISIT15_APPOINTMENT_TYPE_ID;
export const ATHENA_FUVISIT30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_FUVISIT30_APPOINTMENT_TYPE_ID;
export const ATHENA_B2B_FOLLOWUP15_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_B2B_FOLLOWUP15_APPOINTMENT_TYPE_ID;
export const ATHENA_B2B_FOLLOWUP30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_B2B_FOLLOWUP30_APPOINTMENT_TYPE_ID;
export const ATHENA_B2B_CONSULT30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_B2B_CONSULT30_APPOINTMENT_TYPE_ID;
export const ATHENA_MENO15_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_MENO15_APPOINTMENT_TYPE_ID;
export const ATHENA_MENO30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_MENO30_APPOINTMENT_TYPE_ID;
export const ATHENA_WEIGHTLOSS15_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_WEIGHTLOSS15_APPOINTMENT_TYPE_ID;
export const ATHENA_WEIGHTLOSS30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_WEIGHTLOSS30_APPOINTMENT_TYPE_ID;
export const ATHENA_B2B_WEIGHTLOSS15_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_B2B_WEIGHTLOSS15_APPOINTMENT_TYPE_ID;
export const ATHENA_B2B_WEIGHTLOSS30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_B2B_WEIGHTLOSS30_APPOINTMENT_TYPE_ID;
export const ATHENA_ASYNC_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_ASYNC_APPOINTMENT_TYPE_ID;
export const ATHENA_ASYNC_MEMBER_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_ASYNC_MEMBER_APPOINTMENT_TYPE_ID;
export const ATHENA_NEW_NUTRITIONIST_30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_NEW_NUTRITIONIST_30;
export const ATHENA_BRIDGE_FUVISIT15_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_BRIDGE_FUVISIT15_APPOINTMENT_TYPE_ID;
export const ATHENA_BRIDGE_FUVISIT30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_BRIDGE_FUVISIT30_APPOINTMENT_TYPE_ID;
export const ATHENA_BRIDGE_NEWVISIT30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_BRIDGE_NEWVISIT30_APPOINTMENT_TYPE_ID;
export const ATHENA_BRIDGE_MEMBER_CONSULT30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_BRIDGE_MEMBER_CONSULT30_APPOINTMENT_TYPE_ID;
export const ATHENA_BRIDGE_MEMBER_FOLLOWUP15_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_BRIDGE_MEMBER_FOLLOWUP15_APPOINTMENT_TYPE_ID;
export const ATHENA_BRIDGE_MEMBER_FOLLOWUP30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_BRIDGE_MEMBER_FOLLOWUP30_APPOINTMENT_TYPE_ID;
export const ATHENA_BRIDGE_MENO15_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_BRIDGE_MENO15_APPOINTMENT_TYPE_ID;
export const ATHENA_BRIDGE_MENO30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_BRIDGE_MENO30_APPOINTMENT_TYPE_ID;
export const ATHENA_BRIDGE_WEIGHTLOSS15_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_BRIDGE_WEIGHTLOSS15_APPOINTMENT_TYPE_ID;
export const ATHENA_BRIDGE_WEIGHTLOSS30_APPOINTMENT_TYPE_ID = window._env_.REACT_APP_ATHENA_BRIDGE_WEIGHTLOSS30_APPOINTMENT_TYPE_ID;

export const getAppointmentTypeFromAppointmentTypeId = (appointmentTypeId) => {
  if (!appointmentTypeId) return '';

  switch (appointmentTypeId.toString()) {
    case ATHENA_MENO15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_MENO30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_MENO15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_MENO30_APPOINTMENT_TYPE_ID.toString():
      return 'MENOPAUSE';

    case ATHENA_WEIGHTLOSS15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_WEIGHTLOSS30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_B2B_WEIGHTLOSS15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_B2B_WEIGHTLOSS30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_WEIGHTLOSS15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_WEIGHTLOSS30_APPOINTMENT_TYPE_ID.toString():
      return 'WEIGHTLOSS';

    case ATHENA_CONSULT30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_MEMBER_CONSULT30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_RETURNVISIT30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_MEMBER_FOLLOWUP15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_FOLLOWUP15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_FUVISIT15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_NEWVISIT30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_MEMBER_FOLLOWUP30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_FUVISIT30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_B2B_CONSULT30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_B2B_FOLLOWUP15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_B2B_FOLLOWUP30_APPOINTMENT_TYPE_ID.toString():

    case ATHENA_BRIDGE_MEMBER_CONSULT30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_MEMBER_FOLLOWUP15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_MEMBER_FOLLOWUP30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_FUVISIT15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_NEWVISIT30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_FUVISIT30_APPOINTMENT_TYPE_ID.toString():
      return 'HYPO';

    case ATHENA_ASYNC_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_ASYNC_MEMBER_APPOINTMENT_TYPE_ID.toString():
      return 'ASYNC';

    case ATHENA_NEW_NUTRITIONIST_30_APPOINTMENT_TYPE_ID.toString():
    case '17':
    case '41':
      return 'NUTRITIONIST';

    case ATHENA_ZOCDOC30NP_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_ZOCDOC15NP_APPOINTMENT_TYPE_ID.toString():
      return 'ZOCDOC';

    default:
      return '';
  }
};

export const isBridgeAppointment = (appointmentTypeId) => {
  if (!appointmentTypeId) return false;

  switch (appointmentTypeId.toString()) {
    case ATHENA_BRIDGE_MENO15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_MENO30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_WEIGHTLOSS15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_WEIGHTLOSS30_APPOINTMENT_TYPE_ID.toString():

    case ATHENA_BRIDGE_MEMBER_CONSULT30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_MEMBER_FOLLOWUP15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_MEMBER_FOLLOWUP30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_FUVISIT15_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_NEWVISIT30_APPOINTMENT_TYPE_ID.toString():
    case ATHENA_BRIDGE_FUVISIT30_APPOINTMENT_TYPE_ID.toString():
      return true;

    default:
      return false;
  }
};

export const isMenoAppointment = (appointmentTypeId) => {
  if (!appointmentTypeId) return false;

  return getAppointmentTypeFromAppointmentTypeId(appointmentTypeId.toString()) === 'MENOPAUSE';
};

export const isWeightLossAppointment = (appointmentTypeId) => {
  if (!appointmentTypeId) return false;

  return getAppointmentTypeFromAppointmentTypeId(appointmentTypeId.toString()) === 'WEIGHTLOSS';
};

export const isNutritionistAppointment = (appointmentTypeId) => {
  if (!appointmentTypeId) return false;

  return getAppointmentTypeFromAppointmentTypeId(appointmentTypeId) === 'NUTRITIONIST';
};

/*
 return only Hypo. NOT ASYNC nor ZOCDOC
*/
export const isHypoAppointmentStrict = (appointmentTypeId) => {
  if (!appointmentTypeId) return false;

  return getAppointmentTypeFromAppointmentTypeId(appointmentTypeId) === 'HYPO';
};

/*
 return all Hypo. (including ASYNC and ZOCDOC)
*/
export const isHypoAppointmentAll = (appointmentTypeId) => {
  if (!appointmentTypeId) return false;

  return (
    getAppointmentTypeFromAppointmentTypeId(appointmentTypeId) === 'HYPO' ||
    getAppointmentTypeFromAppointmentTypeId(appointmentTypeId) === 'ASYNC' ||
    getAppointmentTypeFromAppointmentTypeId(appointmentTypeId) === 'ZOCDOC'
  );
};

export const isAsyncAppointment = (appointmentTypeId) => {
  if (!appointmentTypeId) return false;

  return getAppointmentTypeFromAppointmentTypeId(appointmentTypeId) === 'ASYNC';
};

export const isZocDocAppointment = (appointmentTypeId) => {
  if (!appointmentTypeId) return false;

  return getAppointmentTypeFromAppointmentTypeId(appointmentTypeId) === 'ZOCDOC';
};
